import { Component, inject } from '@angular/core';
import { MatButton } from '@angular/material/button';
import {
	MAT_DIALOG_DATA,
	MatDialogActions,
	MatDialogContent,
	MatDialogRef,
	MatDialogTitle,
} from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MsalService } from '@azure/msal-angular';
import { APP_INSIGHTS } from '../../../shared/logging/appinsights.factory';

export interface LvrErrorData {
	title: string;
	message: string;
	stackTrace?: string;
	currentUrl?: string;
}

@Component({
	selector: 'lvr-error-dialog',
	templateUrl: './error-dialog.html',
	styleUrl: './error-dialog.scss',
	imports: [MatDialogActions, MatDialogContent, MatDialogTitle, MatButton],
})
export class LvrErrorDialog {
	private readonly msal = inject(MsalService);
	private readonly ai = inject(APP_INSIGHTS);
	private readonly toast = inject(MatSnackBar);
	private readonly dialogRef = inject(MatDialogRef<LvrErrorDialog>);
	public readonly aiTraceId = this.ai.getTraceCtx()?.getTraceId();
	public readonly userData = this.msal.instance.getAllAccounts()[0];
	public readonly data = inject<LvrErrorData>(MAT_DIALOG_DATA);

	public close() {
		this.dialogRef.close();
	}

	public async copyToClipboard() {
		const copyObject = {
			message: this.data.message,
			title: this.data.title,
			stackTrace: this.data.stackTrace,
			currentUrl: this.data.currentUrl,
			aiTraceId: this.aiTraceId,
			username: this.userData.username,
			tenantId: this.userData.tenantId,
		};
		try {
			await navigator.clipboard.writeText(JSON.stringify(copyObject, null, 2));
			this.toast.open('In Zwischenablage kopiert', '', {
				duration: 3000,
				verticalPosition: 'top',
				horizontalPosition: 'right',
				panelClass: ['toast-success'],
			});
		} catch {
			this.toast.open('Fehler beim Kopieren der Fehlerdetails.', '', {
				duration: 3000,
				verticalPosition: 'top',
				horizontalPosition: 'right',
				panelClass: ['toast-error'],
			});
		}
	}
}
